const MatchLaterReason = {
  MOTO: 'moto',
  OTHER: 'other',
};

module.exports = MatchLaterReason;
